import { render, staticRenderFns } from "./RealnameAuthenticationDelog.vue?vue&type=template&id=9ed64d0e&scoped=true"
import script from "./RealnameAuthenticationDelog.vue?vue&type=script&lang=js"
export * from "./RealnameAuthenticationDelog.vue?vue&type=script&lang=js"
import style0 from "./RealnameAuthenticationDelog.vue?vue&type=style&index=0&id=9ed64d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed64d0e",
  null
  
)

export default component.exports